import { Box, Typography } from "@mui/material";
import React from "react";
import "../CSS/TitleBox.css";

export default function HtgTitle() {
  return (
    <Box className="TitleBox" sx={{ backgroundColor: "secondary.main" }}>
      <Typography
        className="title-text"
        sx={{ textAlign: "center", color: "text.main" }}
      >
        How They Grow
      </Typography>
    </Box>
  );
}
